import CatSubGradeDropdown from '@/components/cat-sub-grade-drpdn/cat-sub-grade-drpdn';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'nav-route-map-view',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cat-sub-grade-drpdn': CatSubGradeDropdown,
    },
})

export default class NavRouteMapView extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: {} })
    private value: any;

    @Prop()
    private categorySubjectData: any;

    private updateValue: any;

    private isWithGrades: any = false;

    private isWithFw: any = false;

    private subSetting: boolean = false;

    @Prop()
    private isReadOnly: any;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private content: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private cateogryOptions: any = [];

    private subjectAndFwList: any = [];

    private selectedRecentItem: any = {};

    private isLoading: any = false;

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (!this.isReadOnly) {
            this.fetchCategoryList();
            // this.fetchDisplayProp();
        }

    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private updateCatSub(value: any) {
        this.updateValue = value;
        this.onUpdate();
    }

    private onChangeConfig(value: any) {
        this.subSetting = value;
        this.onUpdate();
    }

    private onUpdate() {
        if (!this.isWithGrades && !this.isWithFw) {
            if (this.updateValue && this.updateValue.subjects && this.updateValue.subjects.selectedItems) {
                this.$emit('input', { [this.updateValue.subjects.selectedItems]: this.subSetting });
            }
        }
    }

    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        // const valueData: any = { "K12.MA": true, "HE.CS": true, "HE.BS": false, "K12.TZM": true };
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];

        for (const prop in valueData) {
            if (Object.prototype.hasOwnProperty.call(valueData, prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    categoryId: propSplit[0],
                    subjectId: prop,
                    keyValue: valueData[prop],
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} = ${iterator.keyValue}; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private fetchCategoryList() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[0],
                    subjectId: prop,
                };
                dataValuesCalculate.push(data);
            }
        }
        this.isLoading = true;
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            for await (const [index, iterator] of categoryList.entries()) {
                const catIndex = dataValuesCalculate.findIndex((item: any) => {
                    return item.categoryId === iterator.code;
                });
                const subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                if (catIndex !== -1) {
                    iterator.preSelect = true;
                    subjectList.filter((subject: any) => dataValuesCalculate.
                        findIndex((dataValue: any) => dataValue.subjectId === subject.id) >= 0)
                        .forEach((selectedNewSubject: any) => {
                            selectedNewSubject.checked = true;
                        });
                }
                iterator.subjects = subjectList;
                if (index >= categoryList.length - 1) {
                    this.isLoading = false;
                    this.selectedRecentItem = categoryList[0];
                    this.subjectAndFwList = this.selectedRecentItem.subjects;
                    this.cateogryOptions = categoryList;
                }
            }
        });
    }

    private selectCategroy(item: any) {
        this.selectedRecentItem = item;
        this.subjectAndFwList = item.subjects;
    }

    private onUpdateFw(itemSub: any) {
        const item = itemSub.id;
        if (itemSub.checked) {
            this.value[item] = true;
        } else {
            delete this.value[item];
        }
        this.$emit('input', this.value);
    }


}
